import { buildCategoricalChartOptions } from './buildCategoricalChartOptions'
import type {
  BuildCategoricalChartOptionsInput,
  CategoricalChartOptions,
} from './chartBuilder.types'
import { markGa4Legend } from './ga4Legend'

/** Stable module-08 chart request surface consumed by dashboards and report presenters. */
export type ChartSpec = BuildCategoricalChartOptionsInput

/** Opaque options accepted by module 02's ChartRoot adapter. */
export type ChartOptions = CategoricalChartOptions

/**
 * Contracted chart builder name. The implementation stays centralized in the closed 30-renderer
 * dispatcher, so public consumers cannot bypass field-role validation or grow a second registry.
 */
export function buildChartOptions(spec: ChartSpec): ChartOptions | null {
  return markGa4Legend(buildCategoricalChartOptions(spec), spec.ga4Fields)
}
